"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.positionEndAdd = exports.positionStartAdd = exports.mergePositions = exports.tokenPosition = exports.isEditorPosition = exports.isTokenEditor = exports.isTokenOffset = exports.isTokenPosition = exports.isParserErrorLevel = exports.ParserError = exports.ParserErrorLevel = exports.TokenPosition = exports.TokenOffset = exports.TokenEditor = exports.EditorPosition = exports.ParserResult = void 0;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
class ParserResult {
    constructor(result, errors) {
        this.result = result;
        this.errors = errors;
        if (this.errors?.length === 0)
            this.errors = undefined;
        Object.freeze(this);
    }
    static success(result) {
        return new ParserResult(result);
    }
    static failure(errors) {
        return new ParserResult(undefined, errors);
    }
    map(f) {
        return new ParserResult(this.result !== undefined ? f(this.result) : undefined, this.errors);
    }
    mapError(f) {
        return new ParserResult(this.result, this.errors !== undefined ? f(this.errors) : undefined);
    }
    flatMap(f) {
        if (this.result !== undefined) {
            const res = f(this.result);
            const errors = (this.errors || []).concat(res.errors || []);
            return new ParserResult(res.result, errors);
        }
        else {
            return new ParserResult(undefined, this.errors);
        }
    }
    fold(onSuccess, onFailure) {
        return this.result !== undefined ? onSuccess(this.result) : onFailure(this.errors || []);
    }
}
exports.ParserResult = ParserResult;
exports.EditorPosition = zod_1.z.object({ line: zod_1.z.number(), column: zod_1.z.number() }).strict();
exports.TokenEditor = zod_1.z.object({ start: exports.EditorPosition, end: exports.EditorPosition }).strict();
exports.TokenOffset = zod_1.z.object({ start: zod_1.z.number(), end: zod_1.z.number() }).strict();
exports.TokenPosition = zod_1.z.object({ offset: exports.TokenOffset, position: exports.TokenEditor }).strict();
exports.ParserErrorLevel = zod_1.z.enum(['error', 'warning', 'info', 'hint']);
exports.ParserError = exports.TokenPosition.extend({ message: zod_1.z.string(), kind: zod_1.z.string(), level: exports.ParserErrorLevel }).strict();
const isParserErrorLevel = (value) => typeof value === 'string' && ['error', 'warning', 'info', 'hint'].includes(value);
exports.isParserErrorLevel = isParserErrorLevel;
const isTokenPosition = (value) => (0, utils_1.isObject)(value) && ('offset' in value && (0, exports.isTokenOffset)(value.offset)) && ('position' in value && (0, exports.isTokenEditor)(value.position));
exports.isTokenPosition = isTokenPosition;
const isTokenOffset = (value) => (0, utils_1.isObject)(value) && ('start' in value && typeof value.start === 'number') && ('end' in value && typeof value.end === 'number');
exports.isTokenOffset = isTokenOffset;
const isTokenEditor = (value) => (0, utils_1.isObject)(value) && ('start' in value && (0, exports.isEditorPosition)(value.start)) && ('end' in value && (0, exports.isEditorPosition)(value.end));
exports.isTokenEditor = isTokenEditor;
const isEditorPosition = (value) => (0, utils_1.isObject)(value) && ('line' in value && typeof value.line === 'number') && ('column' in value && typeof value.column === 'number');
exports.isEditorPosition = isEditorPosition;
const tokenPosition = (offsetStart, offsetEnd, positionStartLine, positionStartColumn, positionEndLine, positionEndColumn) => ({ offset: { start: offsetStart, end: offsetEnd }, position: { start: { line: positionStartLine, column: positionStartColumn }, end: { line: positionEndLine, column: positionEndColumn } } });
exports.tokenPosition = tokenPosition;
const mergePositions = (positions) => {
    const pos = positions.filter(utils_1.isNotUndefined).filter(p => !!p.offset);
    return ({
        offset: { start: posStart(pos.map(p => p.offset.start)), end: posEnd(pos.map(p => p.offset.end)) },
        position: {
            start: { line: posStart(pos.map(p => p.position.start.line)), column: posStart(pos.map(p => p.position.start.column)) },
            end: { line: posEnd(pos.map(p => p.position.end.line)), column: posEnd(pos.map(p => p.position.end.column)) }
        }
    });
};
exports.mergePositions = mergePositions;
const positionStartAdd = (pos, value) => ({
    ...pos,
    offset: { ...pos.offset, start: pos.offset.start + value },
    position: { ...pos.position, start: { ...pos.position.start, column: pos.position.start.column + value } }
});
exports.positionStartAdd = positionStartAdd;
const positionEndAdd = (pos, value) => ({
    ...pos,
    offset: { ...pos.offset, end: pos.offset.end + value },
    position: { ...pos.position, end: { ...pos.position.end, column: pos.position.end.column + value } }
});
exports.positionEndAdd = positionEndAdd;
const posStart = (values) => {
    const valid = values.filter(n => n >= 0 && !Number.isNaN(n) && Number.isFinite(n));
    return valid.length > 0 ? Math.min(...valid) : 0;
};
const posEnd = (values) => {
    const valid = values.filter(n => n >= 0 && !Number.isNaN(n) && Number.isFinite(n));
    return valid.length > 0 ? Math.max(...valid) : 0;
};
//# sourceMappingURL=parserResult.js.map